import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { PeriodoContable } from '../../../models/periodo-contable';
import { TipoDocumento } from '../../../models/tipo-documento';
import * as moment from 'moment';
import { UtilsService } from '../../../services/utils.service';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { AsientoContableService } from '../../../services/asiento-contable.service';
import { SessionService } from '../../../services/session.service';
import { CuentaContableModalComponent } from '../cuenta-contable-modal/cuenta-contable-modal.component';
import { CuentaContable } from '../../../models/cuenta-contable';
import { CuentaContableAsientoModalComponent } from '../cuenta-contable-asiento-modal/cuenta-contable-asiento-modal.component';

@Component({
  selector: 'app-asiento-contable-edit-modal',
  templateUrl: './asiento-contable-edit-modal.component.html',
  styleUrls: ['./asiento-contable-edit-modal.component.css'],
  providers: [
    PeriodoContableService,
    TipoComprobanteService,
    AsientoContableService,
  ],
})
export class AsientoContableEditModalComponent implements OnInit {
  @Input() asiento_id: number;
  @ViewChild('serieFocus') serieElement: ElementRef;
  @ViewChild('punto_emisionFocus') punto_emisionElement: ElementRef;
  @ViewChild('secuencialFocus') secuencialElement: ElementRef;
  @Output() sendEditado = new EventEmitter();
  public asientoContable: AsientoContable;
  public fecha_emision: any;
  public fecha_actual: any;
  public fecha_inicio_periodo: any;
  public tiposComprobante: Array<TipoDocumento>;
  public periodos: Array<PeriodoContable>;
  public vl: Validation;
  public totalDebe: number;
  public totalHaber: number;
  public calculo_decimales: number;
  public msgSweet: SweetMessage;
  public loading: boolean;
  public is_focusedPuntoEmision: boolean;
  public mask: any;
  constructor(
    public bsModalRef: BsModalRef,
    public bsModalRef2: BsModalRef,
    private modalService: BsModalService,
    public utils: UtilsService,
    private periodoContableService: PeriodoContableService,
    private tipoComprobanteService: TipoComprobanteService,
    public asientoContableService: AsientoContableService,
    private ss: SessionService,
  ) { 
    this.asientoContable = new AsientoContable();
    this.msgSweet = new SweetMessage();
    this.fecha_emision = moment(this.fecha_emision);
    this.fecha_actual = moment().format("YYYY-MM-DD");
    this.tiposComprobante = [];
    this.periodos = [];
    this.calculo_decimales = 2;
    this.totalDebe = 0;
    this.totalHaber = 0;
    this.vl = new Validation();
    this.loading = false;
    this.is_focusedPuntoEmision = false;
    this.mask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,/\d/,/\d/,/\d/,/\d/,/\d/,];
    // this.sendEditado = false;
  }

  ngOnInit() {
    
    this.getAsientoById();
    this.getPeriodos();
    this.getTiposComprobante();
    
  }

  onFocus(event){
    let long = (event.target.value).toString().length;
    
      setTimeout(()=>{ 
        if( long == 3 && !this.is_focusedPuntoEmision ){
          this.punto_emisionElement.nativeElement.focus();
          this.is_focusedPuntoEmision = true;
        }else if( long == 3 && this.is_focusedPuntoEmision ){
          this.secuencialElement.nativeElement.focus();
        }else if( long == 3){
          this.serieElement.nativeElement.focus();
        }
      },0);
    
     
  }

  getAsientoById(){    
    let qs = '?embed=tipocomprobante,periodo,detalle?embed=cuenta';
    return new Promise ( (resolve, reject) => {
      this.asientoContableService.getById(this.asiento_id, qs).subscribe(
        res => {
          
          this.asientoContable = res.data;
          this.asientoContable.detalle.forEach(cuenta => {
            cuenta.debe = this.utils.redondear(cuenta.debe, this.calculo_decimales);
            cuenta.haber = this.utils.redondear(cuenta.haber, this.calculo_decimales);
          });
          this.recalcularCuenta();
          resolve(true);
        },
        err => {
          reject();
        }
      );
    });   
  }

  onChangePeriodo(){
    
    this.fecha_inicio_periodo = moment(this.asientoContable.periodo.fecha_inicio.toString()).format("YYYY-MM-DD");
    this.fecha_actual = moment(this.asientoContable.periodo.fecha_fin.toString()).format("YYYY-MM-DD");
  }

  getPeriodos(){
    return new Promise( (resolve, reject) => {
      this.periodoContableService.getAll("?empresa_id=" + this.ss.getData('empresa_id')).subscribe(
        res =>{
          
          this.periodos = res.data;
          this.fecha_inicio_periodo = moment(this.asientoContable.periodo.fecha_inicio.toString()).format("YYYY-MM-DD");
        
          resolve(true);
        },
        err =>{
          reject();
      });
    });
  }

  getTiposComprobante(){
    return new Promise((resolve, reject)=>{

      this.tipoComprobanteService.getAll("?sort=nombre&in[id]=1,2,3,6,8,10,12").subscribe(
        res => {
            if( res.data.length ){
                this.tiposComprobante = res.data;
            }else{
                this.tiposComprobante = [];
            }
            resolve(true);
        },
        err => {
            this.tiposComprobante = [];
            reject(err);
        }
      );
    });
  }

  onSearchCuentaContable(){
    this.bsModalRef = this.modalService.show(CuentaContableAsientoModalComponent, Object.assign({}, {class: 'modal-xlg'}));

    this.bsModalRef.content.sendCuenta.subscribe((value) => {
      this.sendObjectCuentaContable(value)
    });
      
  }

  sendObjectCuentaContable(cuentaContable:CuentaContable){
    let asientoContableDetalle = new AsientoContableDetalle();
    asientoContableDetalle.asiento_cuenta_id = this.asientoContable.id;
    asientoContableDetalle.usuario_id = this.ss.getData('usuario_id');
    asientoContableDetalle.empresa_id = this.ss.getData('empresa_id');
    asientoContableDetalle.cuenta = cuentaContable;

    asientoContableDetalle.cuenta_contable_id = cuentaContable.id;
    this.asientoContable.detalle.push(asientoContableDetalle);
  }

  onDelete(i) {
    this.asientoContable.detalle.splice(i, 1);
    this.recalcularCuenta();
  }

  recalcularCuenta() {
		this.totalDebe = 0;
		this.totalHaber = 0;
		this.asientoContable.detalle.forEach(asientoDetalle => {		
      this.totalDebe += (parseFloat(asientoDetalle.debe.toString()));
			this.totalDebe = this.utils.redondear(this.totalDebe, this.calculo_decimales);
      this.totalHaber += (parseFloat(asientoDetalle.haber.toString()));
			this.totalHaber = this.utils.redondear(this.totalHaber, this.calculo_decimales);
    });
	
  }

  isValidForm(){
    if( this.asientoContable.tipo_comprobante_id && this.asientoContable.numero_documento == ""){
      return false;
    }
    if( this.totalHaber == 0 && this.totalDebe == 0 ){
     
      return false;
    }

    if( (this.totalHaber > 0 || this.totalDebe > 0) && this.totalDebe != this.totalHaber){
      return false;
    }
    return true;
  }

  onSubmit(){
    

    this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la modificación?").then(
			res => {
				
        this.asientoContable.total = this.totalDebe;
        
				this.loading = true;
				this.asientoContableService.update(this.asientoContable).subscribe(
					res => {
            this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente' );
            this.sendEditado.emit(true);
            this.loading = false;
					},
					err => { 
						this.loading = false;
						this.msgSweet.showMessage('error-message', err);
					}
				);
			}
		);
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/asiento-contable-edit-modal/asiento-contable-edit-modal.component.ts